import React, { Component } from 'react'
import { BottomNavigation, FontIcon } from 'react-md'
import { Link } from 'gatsby'

const links = [
  {
    label: 'Programa',
    icon: <FontIcon>event</FontIcon>,
    to: '/',
    component: Link,
  },
  {
    label: 'Preferits',
    icon: <FontIcon>favorite</FontIcon>,
    to: '/preferits',
    component: Link,
  },
  {
    label: 'Informació',
    icon: <FontIcon>info</FontIcon>,
    to: '/info',
    component: Link,
  },
]

class Navigation extends Component {
  render() {
    return (
      <div>
        <BottomNavigation dynamic links={links} colored />
      </div>
    )
  }
}

export default Navigation
